import ModelAttribute from './ModelAttritube'

const ModelTraits = (props: {
  personality?: string
  occupation?: string
  hobbies?: string
  relationship?: string
  bodyType?: string
  age?: string
  butt?: string
  hair?: string
  breasts?: string
  ethnicity?: string
}) => {
  return (
    <div>
      <div class="mb-2 mt-8 font-clash md:mt-4">ABOUT ME:</div>
      <div class="grid grid-cols-2 gap-x-10 gap-y-5 lg:grid-cols-3 xl:grid-cols-4">
        <ModelAttribute
          title="PERSONALITY"
          value={props.personality}
          image={'/images/icons/personality.png'}
        />
        <ModelAttribute
          title="OCCUPATION"
          value={props.occupation}
          image={'/images/icons/occupation.png'}
        />
        <ModelAttribute title="HOBBIES" value={props.hobbies} image={'/images/icons/hobbies.png'} />
        <ModelAttribute
          title="RELATIONSHIP"
          value={props.relationship}
          image={'/images/icons/relationship.png'}
        />
        <ModelAttribute title="BODY" value={props.bodyType} image={'/images/icons/body.png'} />
        <ModelAttribute title="AGE" value={props.age} image={'/images/icons/age.png'} />
        <ModelAttribute title="BUTT" value={props.butt} image={'/images/icons/butt.png'} />
        <ModelAttribute title="Hair" value={props.hair} image={'/images/icons/hair.png'} />
        <ModelAttribute title="BREASTS" value={props.breasts} image={'/images/icons/breasts.png'} />
        <ModelAttribute
          title="ETHNICITY"
          value={props.ethnicity}
          image={'/images/icons/ethnicity.png'}
        />
      </div>
    </div>
  )
}

export default ModelTraits
